import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
    display: 'flex',
    flexDirection: 'column'
  },
  dialogTitle: {
    borderBottom: '1px solid #f0f0f0',
    padding: '20px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& h5': {
      fontWeight: 600,
      fontSize: '20px',
      color: '#2c3e50'
    }
  },
  closeButton: {
    color: '#757575'
  },
  dialogContent: {
    padding: '24px'
  },
  sectionLabel: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#455a64'
  },
  lockedNote: {
    fontSize: '12px',
    fontWeight: 400,
    color: '#9e9e9e'
  },
  radioCard: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '8px 16px',
    border: `1px solid ${theme?.palette?.divider ?? '#e0e0e0'}`,
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'border-color 0.2s, background-color 0.2s',
    userSelect: 'none'
  },
  radioCardSelected: {
    borderColor: theme.palette.primary.main,
    backgroundColor: 'rgba(3, 169, 244, 0.08)'
  },
  radioCardDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
    pointerEvents: 'none'
  },
  radioCardLabel: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.text.primary
  },
  fieldsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  counterBox: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  circularProgress: {
    position: 'absolute',
    right: 0,
    paddingRight: '36px',
    marginTop: '4px',
    zIndex: 1
  },
  conflictBanner: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '14px 16px',
    backgroundColor: 'rgba(255, 152, 0, 0.08)',
    border: '1px solid rgba(255, 152, 0, 0.4)',
    borderRadius: '8px'
  },
  conflictIcon: {
    color: '#e65100',
    fontSize: '22px',
    flexShrink: 0,
    marginTop: '2px'
  },
  conflictText: {
    fontSize: '13px',
    color: '#4e2600',
    lineHeight: 1.6,
    marginBottom: '6px'
  },
  conflictQuestion: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#4e2600',
    marginBottom: '4px'
  },
  conflictHint: {
    fontSize: '12px',
    color: '#6d4c41',
    lineHeight: 1.5,
    marginTop: '2px'
  },
  conflictYesBtn: {
    backgroundColor: '#ff9800',
    color: '#fff',
    textTransform: 'none',
    fontSize: '12px',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#e65100'
    }
  },
  conflictNoBtn: {
    borderColor: '#ff9800',
    color: '#e65100',
    textTransform: 'none',
    fontSize: '12px',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: 'rgba(255, 152, 0, 0.08)'
    }
  },
  dialogFooter: {
    flexShrink: 0,
    padding: '0 24px 16px'
  },
  actions: {
    justifyContent: 'flex-end',
    marginTop: '16px'
  },
  typePrompt: {
    fontSize: '14px',
    color: '#9e9e9e',
    textAlign: 'center',
    padding: '24px 0'
  },

  /* ── Two-column layout ── */
  twoColLayout: {
    display: 'flex',
    gap: '0px',
    alignItems: 'flex-start'
  },
  formCol: {
    flex: '1 1 0',
    minWidth: 0,
    paddingRight: '24px',
    borderRight: '1px solid #f0f0f0'
  },
  previewCol: {
    flex: '0 0 40%',
    minWidth: 0,
    paddingLeft: '24px',
    display: 'flex',
    flexDirection: 'column'
  },
  previewColHeading: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#455a64',
    marginBottom: '12px'
  },

  /* ── Preview panel ── */
  previewCaption: {
    fontSize: '11px !important',
    fontWeight: '700 !important',
    color: '#888 !important',
    letterSpacing: '0.06em',
    display: 'block',
    marginBottom: '5px',
    lineHeight: '1.4 !important'
  },
  labelInput: {
    width: '100%',
    boxSizing: 'border-box',
    border: '1px solid #c4c4c4',
    borderRadius: '8px',
    padding: '7px 12px',
    fontSize: '14px',
    outline: 'none',
    fontFamily: 'inherit',
    '&:focus': {
      borderColor: theme.palette.primary.main
    }
  },
  labelHelper: {
    fontSize: '11px !important',
    color: '#aaa',
    marginTop: '4px !important'
  },
  recentsHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '6px'
  },
  clearBtn: {
    fontSize: '12px',
    padding: '1px 6px',
    color: '#aaa',
    minWidth: 'unset',
    textTransform: 'none'
  },
  chipRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px'
  },
  recentChip: {
    cursor: 'pointer',
    fontSize: '12px'
  },
  noRecents: {
    fontSize: '12px',
    color: '#ccc',
    fontStyle: 'italic'
  },
  printOptions: {
    display: 'flex',
    gap: '24px',
    marginBottom: '12px'
  },
  segmentedGroup: {
    display: 'inline-flex',
    border: '1.5px solid #e0e0e0',
    borderRadius: '8px',
    overflow: 'hidden',
    backgroundColor: '#f5f5f5'
  },
  segmentedOption: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '11px',
    fontWeight: 500,
    color: '#888',
    cursor: 'pointer',
    padding: '5px 12px',
    backgroundColor: 'transparent',
    userSelect: 'none',
    transition: 'background-color 0.15s, color 0.15s',
    whiteSpace: 'nowrap',
    '&:not(:last-child)': {
      borderRight: '1.5px solid #e0e0e0'
    },
    '&:hover': { color: '#15b4db', backgroundColor: '#e6f7fb' }
  },
  segmentedOptionActive: {
    backgroundColor: '#fff',
    color: '#15b4db',
    fontWeight: 700,
    boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.06)'
  },
  previewArea: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    minHeight: '200px',
    padding: '16px'
  },
  previewCenter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  previewHint: {
    fontSize: '13px',
    color: '#aaa',
    textAlign: 'center'
  }
}))
